var _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconAngle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon-angle")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    d: "M27.196 1.511c0.66-0.694 1.742-0.694 2.402 0 0.599 0.63 0.642 1.615 0.128 2.296l-0.128 0.151-13.761 14.467 0.062 0.077c1.983 2.552 3.241 5.592 3.661 8.838l0.069 0.611 0.006 0.081 16.057 0.001c0.812 0 1.482 0.591 1.647 1.372l0.029 0.183 0.010 0.189c0 0.894-0.652 1.639-1.5 1.734l-0.185 0.010h-33.016c-0.688 0-1.303-0.432-1.56-1.086-0.047-0.12-0.081-0.244-0.101-0.37-0.013-0.082-0.021-0.165-0.023-0.251-0.008-0.401 0.118-0.793 0.356-1.109l0.129-0.152 25.721-27.044zM13.454 20.93l-6.755 7.104h9.548l-0.072-0.548c-0.337-2.225-1.165-4.321-2.426-6.146l-0.295-0.41z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAngle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-angle.1e76ea25.svg";
export { ForwardRef as ReactComponent };